export enum OccupancyType {
  Owner = 'Owner',
  Renter = 'Renter',
}

export const OCCUPANCY_TYPES = [
  {
    value: OccupancyType.Owner,
    label: 'Yes, I own this property.',
  },
  {
    value: OccupancyType.Renter,
    label: 'No, I am renting this property.',
  },
];
